import { Module } from 'wrapper6'
import ObjectFitClass from '../utils/_object-fit'

const $ = jQuery

export default class CasesFilter extends Module {
  ready (app) {
    this.LOADER = document.querySelector('#loader')
    this.wrapper = document.querySelector('.mtt-archive')
    this.search = document.querySelector('#cases-search')
    this.catsSelect = document.querySelector('#cases-cats')
    this.postsDestination = document.querySelector('.mtt-archive__posts-inner')
    this.paginationDestination = document.querySelector('#cases-pagination')

    if (document.querySelector('.mtt-archive')) {
      this.pagination = document.querySelector('.mtt-archive').querySelector('#cases-pagination')
    }

    this.pageNumber = 0
    this.searchValue = ''
    this.cat = ''

    this.addSearch()
    this.addCategoryFilter()
    this.addPagination()
  }

  addSearch () {
    if (this.search) {
      let timeout = null

      this.search.addEventListener('input', (e) => {
        e.preventDefault()

        if (timeout) {
          clearTimeout(timeout)
        }

        timeout = setTimeout(() => {
          this.pageNumber = 0
          this.searchValue = this.search.value
          this.getPosts()
        }, 500)
      })
    }
  }

  addCategoryFilter () {
    if (this.catsSelect) {
      this.catsSelect.addEventListener('change', () => {
        this.pageNumber = 0
        this.getPosts()
      })
    }
  }

  addPagination () {
    if (this.pagination) {
      this.pagination.addEventListener('click', (e) => {
        e.preventDefault()
        this.pageNumber = e.target.getAttribute('data-page')
        this.getPosts()
      })
    }
  }

  getPosts () {
    this.LOADER.classList.add('show')

    $('html, body').animate({
      scrollTop: $('.mtt-archive__posts').offset().top - 150
    }, 500)

    const data = {
      action: 'filter_cases',
      s: this.searchValue,
      cat: this.catsSelect ? this.catsSelect.value : this.wrapper.getAttribute('data-cat'),
      pageNumber: this.pageNumber
    }

    $.post(main_theme_objects.ajax_url, data, (response) => {
      if (response.posts !== '') {
        this.postsDestination.innerHTML = response.posts
        new ObjectFitClass()
      } else {
        this.postsDestination.innerHTML = '<p class="no-posts"> Der er desværre ingen cases der opnår disse kriterier. </p>'
      }

      this.paginationDestination.innerHTML = response.pagination

      this.LOADER.classList.remove('show')
    })
  }
}
